<div class="divider" [ngClass]="{ vertical: orientation === 'y' }">
  <div class="divider__line"></div>
  <ng-content></ng-content>
  <div class="divider__line"></div>
</div>
